import {
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsUUID,
} from 'class-validator';

/**
 * Maps to a new row in `iam.policy_bindings`.
 * Persisted **`policy_name`** is derived server-side from resource type, principal
 * (group display or user first+last), and role display/name — see
 * `iam-permissions-outline.md` §3.10.
 */
export class GrantAccessDto {
  @IsUUID()
  @IsNotEmpty()
  principalId: string;

  @IsUUID()
  @IsNotEmpty()
  roleId: string;

  @IsUUID()
  @IsNotEmpty()
  resourceId: string;

  @IsNotEmpty()
  resourceType: string;

  /** When false, the binding does not grant (evaluation treats as inactive). Default true. */
  @IsOptional()
  @IsBoolean()
  allow?: boolean;

  /** Epoch milliseconds; when set, the binding is ignored after this instant. */
  @IsOptional()
  @IsNumber()
  expiresAt?: number | null;
}
